export default __webpack_public_path__ + "static/media/loading-2vertical.2a303527.png";